import { render } from "./EmployeeAttendanceRecords.vue?vue&type=template&id=495cecfe&scoped=true"
import script from "./EmployeeAttendanceRecords.vue?vue&type=script&lang=js"
export * from "./EmployeeAttendanceRecords.vue?vue&type=script&lang=js"

import "@/assets/css/hr-page-shared.css?vue&type=style&index=0&lang=css&external"
import "./EmployeeAttendanceRecords.vue?vue&type=style&index=1&id=495cecfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495cecfe"]])

export default __exports__